import React, { useContext } from 'react';
import { IonContent, IonPage, IonButton, IonIcon } from '@ionic/react';
import AppHeader from '../components/AppHeader';
import AccountHeader from '../components/AccountHeader';
import './Home.scss';
import { Laboratory } from '../models';
import {
  COVID_APPOINTMENT_ROUTE,
  COVID_REGISTRATION_ROUTE
} from '../navigators/AppStackNavigator';
import { ThemeContext } from '../components/theme/ThemeProvider';
import { documentOutline } from 'ionicons/icons';

type HomeCovidCheckProps = {
  laboratorySlug?: string;
  laboratories?: Laboratory[];
};

const HomeCovidCheck: React.FC<HomeCovidCheckProps> = ({ laboratories }) => {
  const theme = useContext(ThemeContext);

  return (
    <IonPage>
      <AppHeader />
      <IonContent class="ion-padding">
        <div className="wrapper wrapper--medium wrapper--stretch wrapper--centered-md">
          <div className="ion-hide-lg-up">
            <AccountHeader />
          </div>
          <div className="home-card">
            <header className="home-card__header ion-margin-bottom">
              {theme.home.welcomeText ? (
                <div className="home-card__header__title ion-margin-bottom">
                  <h1
                    className="ion-text-center"
                    dangerouslySetInnerHTML={{ __html: theme.home.welcomeText }}
                  ></h1>
                </div>
              ) : null}
              {theme.home.bodyText ? (
                <p
                  className="home-card__intro"
                  dangerouslySetInnerHTML={{ __html: theme.home.bodyText }}
                ></p>
              ) : null}
            </header>
            <div className="home-card__buttons ion-margin-bottom">
              <div>
                <IonButton
                  routerLink={COVID_REGISTRATION_ROUTE}
                  expand="block"
                  size="large"
                  color="primary"
                  class="large"
                  routerDirection="forward"
                >
                  <div className="home-card__inner-button">
                    <IonIcon icon={documentOutline} />
                    <span>
                      Je dispose d'un test COVID-19 valide ;<br />
                      je pré-enregistre ma venue
                    </span>
                  </div>
                </IonButton>
              </div>
              <div>
                <IonButton
                  routerLink={`${COVID_APPOINTMENT_ROUTE}/laboratoire`}
                  expand="block"
                  size="large"
                  color="primary"
                  class="large"
                  routerDirection="forward"
                >
                  <div className="home-card__inner-button">
                    <IonIcon src={require('../assets/icons/tube.svg')} />
                    <span>
                      Je souhaite réaliser un test COVID-19 dans un laboratoire
                      partenaire
                    </span>
                  </div>
                </IonButton>
              </div>
            </div>
            <IonButton routerLink="/dashboard/faq" expand="block" color="light">
              Foire aux questions
            </IonButton>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default HomeCovidCheck;
